import { useQuery } from '@tanstack/react-query';
import type { Dayjs } from 'dayjs';
import { requestApiGetConjunctions } from './useQueryCdm';
import { AdvancedSearchParamsType, SortType } from '@/types';

const useQueryKorSat = (sort: SortType | undefined, baseDate: Dayjs) => {
  const today = baseDate.utc().startOf('day').subtract(1, 'day');
  const collectionName = `SPACEMAP_CA_${today.format('YYYYMMMDD').toUpperCase()}T0000_S1`;
  return useQuery({
    queryKey: ['nuri-satellites-conjunctions-daily', sort, today.format('YYYY-MM-DD')],
    queryFn: async () => {
      const params: AdvancedSearchParamsType = {
        limit: 100,
        page: 0,
        order: 'ASC',
        sort,
        ids: [66650, 66651, 66652, 66653, 66654, 66655, 66656, 66657, 66658, 66659, 66660, 66661, 66662, 66663],
      };

      const result = await requestApiGetConjunctions(params, collectionName);

      return {
        conjunctions: result.conjunctions,
        totalCount: result.totalCount,
      };
    },
  });
};

export default useQueryKorSat;
